import { Link } from 'react-router-dom';
import type { SpecialItem } from '@/types';
import SectionHeading from '@/components/base/SectionHeading';

interface SpecialSectionProps {
  items: SpecialItem[];
}

export default function SpecialSection({ items }: SpecialSectionProps) {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <SectionHeading
        title="影视专题推荐"
        subtitle="影评合集与观影攻略，一次看个够"
        moreLabel="更多专题"
        moreTo="/special"
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {items.map((item, index) => (
          <Link
            key={item.id}
            to={`/special?id=${item.id}`}
            className={`group relative rounded-lg overflow-hidden border border-background-200/70 flex flex-col ${
              index === 0 ? 'md:col-span-2 md:row-span-1' : ''
            }`}
          >
            <div className={`relative w-full overflow-hidden ${index === 0 ? 'h-56 md:h-64' : 'h-56'}`}>
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title} 影视专题`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/40 to-transparent"></div>
              <span className="absolute top-4 left-4 px-2.5 py-1 rounded-md bg-primary-500/90 text-foreground-950 text-xs">
                专题
              </span>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-accent-400 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1 text-xs text-secondary-300">{item.subtitle}</p>
              <p className="mt-2.5 text-sm text-foreground-600 line-clamp-2">{item.summary}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs text-accent-400">
                查看专题
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}